import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

//The cart holds plain course objects. It used to be handed the array that the
//course details page works with, which meant every entry was itself an array:
//the total came out NaN(reading .price off an array) and the cart page only ever
//rendered the first course. Anything that is not a course object is dropped here,
//so a cart saved in the old shape cannot break the page on the next visit.
const readCart = () => {
    try{
        const stored = JSON.parse(localStorage.getItem("cart"))

        if(!Array.isArray(stored)){
            return []
        }

        return stored.filter((item) => item && !Array.isArray(item) && item._id)
    }
    catch(error){
        //corrupt json, start from an empty cart rather than crashing on load
        return []
    }
}

//Totals are derived from the cart itself so they can never drift out of step
//with it, which is what the separately stored numbers used to allow
const totalOf = (cart) => cart.reduce((sum, course) => sum + (course.price || 0), 0)

const persist = (state) => {
    localStorage.setItem("cart", JSON.stringify(state.cart))
    localStorage.setItem("total", JSON.stringify(state.total))
    localStorage.setItem("totalItems", JSON.stringify(state.totalItems))
}

const initialCart = readCart()

//The initital state of slice
const initialState = {
    cart: initialCart,
    totalItems: initialCart.length,
    total: totalOf(initialCart),
}

//Creating slice using createSlice
const cartSlice = createSlice({
    name: "cart",
    initialState: initialState,
    reducers: {

        //add to cart...expects a single course object
        addToCart: (state, action) => {

            const course = action.payload

            if(!course?._id){
                return
            }

            const index = state.cart.findIndex((item) => item._id === course._id)

            if(index >= 0){
                // If the course is already in the cart, do not add it twice
                toast.error("Course already in cart")
                return
            }

            state.cart.push(course)
            state.totalItems = state.cart.length
            state.total = totalOf(state.cart)

            persist(state)

            toast.success("Course added to cart")
        },

        //remove from cart
        removeFromCart: (state, action) => {

            const courseId = action.payload
            const index = state.cart.findIndex((item) => item._id === courseId)

            if(index >= 0){
                state.cart.splice(index, 1)
                state.totalItems = state.cart.length
                state.total = totalOf(state.cart)

                persist(state)

                toast.success("Course removed from cart")
            }
        },

        //reset cart
        resetCart: (state) => {

            state.cart = []
            state.total = 0
            state.totalItems = 0

            localStorage.removeItem("cart")
            localStorage.removeItem("total")
            localStorage.removeItem("totalItems")
        },
    }
})

export const {addToCart, removeFromCart, resetCart} = cartSlice.actions
export default cartSlice.reducer
